import React, { useState } from 'react';
import { Row } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useDeleteDataExtraction } from '@/hooks';
import { DataExtractionDetails } from '@/components/Settings/DataExtraction/Details';

import { ActionItems } from './components/ActionItems';
import { InlineActions } from './components/InlineActions';
import { DeleteDataExtractionModal } from '@/components/Settings/DataExtraction/Modals';

interface ActionsProps {
	rowData: {
		id: string;
		extraction_name: string;
		content: string[];
		created_at: string;
		author_name: string;
		status: string;
		organization_id: string;
		company_id: string;
	};
}

export function Actions({ rowData }: Readonly<ActionsProps>) {
	const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
	const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
	const { mutateAsync: deleteDataExtraction, isLoading } = useDeleteDataExtraction();
	const btnSize = 'small' as const;

	async function handleConfirmDelete(): Promise<void> {
		await deleteDataExtraction({
			data_extraction_id: rowData.id,
			organization_id: rowData.organization_id,
			company_id: rowData.company_id
		});
		setIsDeleteModalOpen(false);
	}

	function handleCancelDelete(): void {
		setIsDeleteModalOpen(false);
	}

	function handleDeleteClick(): void {
		setIsDeleteModalOpen(true);
	}

	const items = ActionItems({
		rowData,
		onShowDrawer: () => setIsDrawerOpen(true),
		onDeleteActionClick: handleDeleteClick,
		btnSize
	});

	return (
		<>
			<Row align="middle" justify="center">
				<InlineActions items={items} />
			</Row>

			<DataExtractionDetails isOpen={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} data={rowData} />

			<DeleteDataExtractionModal
				visible={isDeleteModalOpen}
				onCancel={handleCancelDelete}
				onConfirm={handleConfirmDelete}
				loading={isLoading}
				customMessage={`${I18n.get('Do you want to delete the extraction')} ${rowData.extraction_name}?`}
			/>
		</>
	);
}
